// File: Admissions.jsx

import { useEffect, useState } from "react";
import {
  Globe,
  BookOpen,
  GraduationCap,
  FileText,
  Mail,
  Briefcase,
} from "lucide-react";
import "./Admissions.css";

const Admissions = ({ countryData }) => {
  const [requirements, setRequirements] = useState(
    countryData.admissionRequirements || []
  );
  const [loading, setLoading] = useState(false);



  if (loading) return <div>Saving admission data...</div>;

  // Six icons for up to six requirements
  const icons = [
    Globe,          // Copy of a valid passport
    BookOpen,       // TOEFL/IELTS/C1 Advanced scores
    GraduationCap,  // GMAT/GRE scores for PG programs
    FileText,       // Academic Transcripts
    Mail,           // Letter of Recommendations (LORs)
    Briefcase,      // Portfolio (for specific courses)
  ];

  return (
    <div className="admissions-container">
      <h1>Admission Requirements for {countryData.name}</h1>
      <p className="requirements-intro">
        Here are the major requirements to study in {countryData.name}:
      </p>

      <div className="requirements-grid">
        {requirements.map((req, idx) => {
          const Icon = icons[idx];
          return (
            <div className="requirement-item" key={idx}>
              <div className="requirement-icon">
                {Icon && <Icon size={24} />}
              </div>
              <div className="requirement-text">{req}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Admissions;
